<template>

    <div class="conditional-formatting-container">
        <div class="close" @click="$emit('close')"><v-icon color="#000000">mdi-close</v-icon></div>
        <div class="title">
            <span>Conditional Formatting - <i>{{$props.conditionalFormattingEditColumn.colId}}</i></span>
            <!-- <span v-text="$props.conditionalFormattingEditColumn.column.colId"></span> -->
        </div>

        <div class="table-container">
            <v-form ref="conditionalFormattingForm" :lazy-validation="true" v-model="formValid">
            <v-simple-table :dense="dense" fixed-header light>

                <template v-slot:default>
                    <thead>
                        <tr>
                            <th class="text-left">Rule</th>
                            <th class="text-left">Condition</th>
                            <th class="text-left">Value</th>
                            <th class="text-left">Color</th>
                            <th class="text-left">Stop if True</th>
                            <th class="text-left">Apply to Row</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(rule, index) in rules" :key="index">
                            <td><b>{{ index + 1 }}</b></td>
                            <td><v-select v-model="rule.condition" color="#c42111" :items="conditionList" :rules="[validation.required(rule.condition, 'Condition')]" dense light /></td>
                            <td><v-text-field v-model="rule.value" type="number" color="#c42111" :rules="[validation.required(rule.value, 'Value')]" dense light /></td>
                            <td>
                                <v-menu v-model="rule.menu" top nudge-bottom="105" nudge-left="16" :close-on-content-click="false">
                                    <template v-slot:activator="{ on }">
                                        <div class="color-swatch" :style="{backgroundColor: rule.color, color: rule.textColor}" v-on="on">
                                            <span>AaBbCcYyZz</span>
                                        </div>
                                    </template>
                                    <v-card>
                                        <v-card-text class="pa-0">
                                            <v-color-picker v-model="rule.color" @input="calcForegroundColor(rule)" flat />
                                        </v-card-text>
                                    </v-card>
                                </v-menu>
                            </td>
                            <td><v-checkbox class="mr-1" v-model="rule.stopIfTrue" color="#c42111" dense light /></td>
                            <td><v-checkbox class="mr-1" v-model="rule.applyToRow" color="#c42111" dense light /></td>
                            <td><v-btn icon @click="deleteRuleClick(rule)"><v-icon>mdi-delete</v-icon></v-btn></td>
                        </tr>
                    </tbody>
                </template>

            </v-simple-table>
            </v-form>
        </div>

        <div class="buttons">
            <v-btn @click="addRule" light>New Rule</v-btn>
            <v-btn class="mr-0 right" @click="okClick" light>Ok</v-btn>
            <v-btn class="mr-3 right" @click="$emit('close')" light>Close</v-btn>
        </div>

        
    </div>
    
</template>

<script>
export default {
    name: 'ConditionalFormattingEdit',
    props: ["conditionalFormattingEditColumn"],
    components: {
    },
    data: () => ({
        rules: [],
        formValid: true,
        dense: false,
        conditionList: [
            {text: 'Less Than', value: 'lt'},
            {text: 'Less Than or Equal', value: 'lte'},
            {text: 'Equal', value: 'eq'},
            {text: 'Greater Than', value: 'gt'},
            {text: 'Greater Than or Equal', value: 'gte'},
        ],

        validation: {
            required: (value, fieldName) => ((value || value === 0) ? true : false) || `${fieldName} is required`,
        }
    }),

    computed: {
    },

    methods: {
        addRule: function() {
            this.rules.push({
                name: "",
                condition: "",
                value: "",
                color: "#dddddd",
                textColor: "#000000",
                stopIfTrue: false
            });
        },

        calcForegroundColor: function(rule) {
            let background = rule.color;
            let r = background.substring(1, 3);
            let g = background.substring(3, 5);
            let b = background.substring(5, 7);
            let o = Math.round(((parseInt(r, 16) * 299) + (parseInt(g, 16) * 587) + (parseInt(b, 16) * 114)) / 1000);
            let foreground = (o > 125) ? '#000000' : '#ffffff';
            rule.textColor = foreground;
        },

        deleteRuleClick: function(rule) {
            this.rules.splice(this.rules.indexOf(rule), 1);
        },

        okClick: function() {
            if(this.$refs.conditionalFormattingForm.validate()) {
                this.$emit('rules', this.rules);
            }
        }
    },

    watch: {

    },

    mounted() {
        if(this.$props.conditionalFormattingEditColumn.colDef.conditionalFormattingRules) {
            this.rules = JSON.parse(JSON.stringify(this.$props.conditionalFormattingEditColumn.colDef.conditionalFormattingRules));
        }
    },

    created() {
    }


};
</script>

<style scoped>

    .conditional-formatting-container {
        width: 800px;
        height: 400px;
        max-width: 80%;
        background-color: #F5F7F7;
        border-radius: 2px;
        border: rgb(189, 195, 199) solid 1px;
        position: absolute;
        top: calc(50% - (400px / 2));
        left: calc(50% - (800px / 2));
        font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
        color: #000000;

        padding: 5px;
        box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.3);
    }

    @media screen and (max-width: 1200px) {
        .conditional-formatting-container {
            width: 600px;
            left: calc(50% - (600px / 2));
        }
    }
    @media screen and (max-width: 750px) {
        .conditional-formatting-container {
            width: 600px;
            left: 30px;
        }
    }

    .close {
        color: rgba(0, 0, 0, 0.54);
        cursor: pointer;
        position: absolute;
        top: 5px;
        right: 5px;
    }

    .title {
        font-size: 16pt;
        color: #000000;
        font-weight: 100;

        border-bottom: rgb(189, 195, 199) solid 1px;
    }

    .table-container {
        margin: 1em 5px 5px 5px;
        position: relative;
        overflow: auto;
        max-height: calc(100% - 120px);
        border: rgb(189, 195, 199) solid 1px;
    }

    .buttons {
        margin: 1em 5px 5px 5px;
    }
    .buttons .right {
        float: right;
    }

    .color-swatch {
        cursor: pointer;
        height: 30px;
        width: 120px;
        border-radius: 4px;
        transition: border-radius 200ms ease-in-out;
        text-align: center;
    }
    .color-swatch span {
        vertical-align: sub;
    }


</style>

